export enum IslandModifier {
	Base = "",
	Small = "small",
	Smaller = "smaller",
}
